import React from 'react';
import iconSizes from 'constants/iconSizes.js';

const style = {
  display: 'inline-block',
  userSelect: 'none',
  flexShrink: 0,
};

const ArrowUpIcon = ({ size = 'xsl', color = 'black', style: overrideStyles = {}, ...attr }) => {
  return (
    <svg style={{ ...style, ...overrideStyles }} {...iconSizes[size]} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...attr}>
      <path d="M1 15.58691L8.58692 7.1738L16.1738 15.58691" stroke={color} />
    </svg>
  );
};

export default ArrowUpIcon;
